/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Translation } from "react-i18next";
import "../../../css/Tariff.css";
import { connect } from "react-redux";
import { countryList } from "../../../models";
// import i18next from "i18next";

class Tariff extends React.Component {
  changeCountryTax = async event => {
    const { fetchDutyTax } = this.props;
    const countryCode = event.target.value;
    await fetchDutyTax(countryCode);
  };
  render() {
    const { countriesList, getCountriesList, activeCountry } = this.props;
    const { existingTotalEstimatedDutiesAndTax, remark } = this.props.dutyTax;
    // const lang = i18next.language;
    return (
      <>
        <section>
          <Translation>{t => <p>{t("tariff.dutiesAndTaxes")}</p>}</Translation>
          <article className="static">
            {getCountriesList && (
              <select
                className="duty-tax-mobile"
                onChange={this.changeCountryTax}
                name="dutyTax"
                value={activeCountry}
              >
                <Translation>
                  {t => (
                    <option value="HK" disabled="disabled">
                      {t("tariff.selectDestinationCountry")}
                    </option>
                  )}
                </Translation>
                {!countriesList.hasOwnProperty("error") &&
                  countriesList.map((data, i) => (
                    <option key={i} value={data.countryIsoCode}>
                      {data.name}
                    </option>
                  ))}
              </select>
            )}
            <div className="duty-tax-table-mobile" style={{ display: "block" }}>
              {activeCountry !== "CN" ? (
                <>
                  <table className="country-tax-table">
                    <tbody>
                      <tr className="country-tax-table-title">
                        <td>
                          <Translation>
                            {t => <>{t("tariff.estimatedTax&Duty")}</>}
                          </Translation>
                        </td>
                        <td>
                          <Translation>
                            {t => <>{t("tariff.remark")}</>}
                          </Translation>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {existingTotalEstimatedDutiesAndTax
                            ? existingTotalEstimatedDutiesAndTax
                            : "-"}
                        </td>
                        <td>
                          {remark ? (
                            <span
                              dangerouslySetInnerHTML={{ __html: remark }}
                            />
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Translation>
                    {t => (
                      <p>
                        <i>{t("tariff.estimatedDutyAndTax")}</i>
                      </p>
                    )}
                  </Translation>
                </>
              ) : (
                <div className="china-duty-text-mobile">
                  <br />
                  <Translation>
                    {t => <>{t("tariff.forShippingChina")}</>}
                  </Translation>
                  <a
                    href="https://cn.emphasis.com"
                    target="_blank"
                    className="content-link"
                    rel="noopener noreferrer"
                  >
                    <Translation>
                      {t => <>{t("tariff.emphasis")}</>}
                    </Translation>
                  </a>
                  <Translation>{t => <>{t("tariff.dot")}</>}</Translation>
                  <br />
                  <br />
                </div>
              )}
            </div>
            <br />
            <Translation>
              {t => <p>{t("tariff.productPricesDisplayed")}</p>}
            </Translation>
          </article>
          <br />
          {/* <p>
            <Translation>
              {t => <>{t("tariff.forDetailsPleaseVisit")}</>}
            </Translation>
            &nbsp;
            <a
              href={`/${lang === "zhTW" ? "tc" : "en"}/help-dutiesandtaxes`}
              target="_blank"
              className="content-link"
              rel="noopener noreferrer"
            >
              <Translation>{t => <>{t("tariff.duties&Taxes")}</>}</Translation>
            </a>
          </p> */}
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    countriesList: state.countryList.countries,
    getCountriesList: state.countryList.getCountriesList,
    dutyTax: state.countryList.dutyTax,
    activeCountry: state.countryList.activeCountry
  };
};
const mapDispatchToProps = () => {
  return {
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Tariff);
